// extracted by mini-css-extract-plugin
module.exports = {"form":"_2zBr9OWs6maVhzKqZnT7ZA","form--changed":"_3DbHgc4IaJkROvmGzMvvi1","form--loading":"_29QDFNoNOFFuAGtV71H6TE","spinner":"_1oc1UP4YvbcKzzEwZ7XWoK"};